export default "__VITE_ASSET__D_gWi1Oa__"